export default {
  USER: 'gp_consult_uk_user',
  AUTH_TOKEN: 'gp_consult_uk_token'
}